import { Link } from 'react-router-dom';
import styles from './Information.module.scss';
import { SectionTitle } from '../../../../SectionTitle/SectionTitle';

const Information = () => {
  return (
    <div className={styles.Information}>
      <SectionTitle className={styles.title}>
        <h2>Информация</h2>
      </SectionTitle>
      <div className={styles.wrapper}>
        <Link to="/documentation">
          <h3>
            Информационное <br />
            письмо
          </h3>
          <picture>
            <source
              srcSet="/images/home/information1_mob.svg"
              media="(width < 1024px)"
            />
            <img src="/images/home/information1.svg" alt="" />
          </picture>
        </Link>
        <Link to="/company">
          <h3>О компании</h3>
          <picture>
            <source
              srcSet="/images/home/information2_mob.svg"
              media="(width < 1024px)"
            />
            <img src="/images/home/information2.svg" alt="" />
          </picture>
        </Link>
        <Link to="/contact">
          <h3>
            Авторизованные <br />
            сервисные <br />
            центры
          </h3>
          <picture>
            <source
              srcSet="/images/home/information3_mob.svg"
              media="(width < 1024px)"
            />
            <img src="/images/home/information3.svg" alt="" />
          </picture>
        </Link>
      </div>
    </div>
  );
};

export default Information;
